export default "__VITE_ASSET__CTuAex1v__"